import { Button, Modal, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import './Svgrendere.scss';

export type ISvgRendereParam = { svgUrl: any; id: string; title: string };

const SVGComponent = ({
  id,
  title,
  loading
}: {
  id: string;
  title: string;
  loading: boolean;
}) => {
  return (
    <div id={id} className="viewerModal">
      {title === 'Compare Prints' ? (
        <>
          <iframe
            className="iframe1"
            id={`svgViewer${id}`}
            src="/viewer/viewer.html"
            title={`myFrame${id}`}
          ></iframe>
          {loading && (
            <div className="iframeLoader">
              <Spin size="large" />
            </div>
          )}
          <iframe
            className="iframe1"
            id={`svgViewers${id}`}
            src="/viewer/viewer.html"
            title={`myFrame${id}`}
          ></iframe>
        </>
      ) : (
        <>
          <iframe
            id={`svgViewer${id}`}
            src="/viewer/viewer.html"
            title={`myFrame${id}`}
          ></iframe>
          {loading && (
            <div className="iframeLoader">
              <Spin size="large" />
            </div>
          )}
        </>
      )}
    </div>
  );
};

const SvgRenderer: React.FC<ISvgRendereParam> = ({ svgUrl, id, title }) => {
  const [svgModal, setSvgModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const saveSvgData = async (svgUrl: string): Promise<void> => {
    if (title === 'View Part') {
      setLoading(true);
      const data = await fetch(svgUrl);
      const textdata = await data.text();

      const iframe: any = document.querySelector(`#svgViewer${id}`);
      iframe.onload = null;
      iframe.src = '';
      iframe.onload = () => {
        iframe.contentWindow.InitializeViewer(textdata, true, () => {
          setLoading(false);
        });
        iframe.onload = null;
      };
      iframe.src = '/viewer/viewer.html';

      //setTimeout(() => {}, 2000);
    } else if (title === 'View Printed Part') {
      setLoading(true);
      const iframe: any = document.querySelector(`#svgViewer${id}`);
      iframe.onload = null;
      iframe.src = '';
      iframe.onload = () => {
        iframe.contentWindow.InitializeViewer(svgUrl, true, () => {
          setLoading(false);
        });
        iframe.onload = null;
      };
      iframe.src = '/viewer/viewer.html';
    } else {
      setLoading(true);
      const data = await fetch(svgUrl[0]);
      const textdata = await data.text();

      const iframe: any = document.querySelector(`#svgViewer${id}`);
      const iframe2: any = document.querySelector(`#svgViewers${id}`);
      iframe.onload = null;
      iframe.src = '';
      iframe2.onload = null;
      iframe2.src = '';
      iframe.onload = () => {
        iframe.contentWindow.InitializeViewer(textdata, true, () => {
          setLoading(false);
        });
        iframe.onload = null;
      };
      iframe2.onload = () => {
        iframe2.contentWindow.InitializeViewer(svgUrl[1], true, () => {
          setLoading(false);
        });
        iframe2.onload = null;
      };
      iframe.src = '/viewer/viewer.html';
      iframe2.src = '/viewer/viewer.html';
    }
  };

  useEffect(() => {
    if (svgModal) {
      saveSvgData(svgUrl);
    }
  }, [svgUrl, svgModal]);

  const handleCancel = () => {
    setSvgModal(false);
  };
  return (
    <>
      <Modal
        visible={svgModal}
        footer={false}
        className="svgModel"
        centered={true}
        width="90vw"
        height="90vh"
        onCancel={() => handleCancel()}
      >
        <SVGComponent id={id} title={title} loading={loading} />
      </Modal>
      <Button onClick={() => setSvgModal(true)}>{title}</Button>
    </>
  );
};

export default SvgRenderer;
